import { useEffect, useMemo, useState } from 'react';
import './App.css';
import './styles/fonts/inter/inter.css';
import StateContext, { usePersistedReducer } from './reducers';
import authReducer, { authInitialState } from './reducers/auth';
import menuReducer, { menuInitialState } from './reducers/menu';
import ApiCaller from './utils/ApiTemplate';
import { BrowserRouter } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import { Box, CssBaseline, GlobalStyles, useMediaQuery, useTheme } from '@mui/material';
import { GlobalStyleTemplate } from './styles';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AppRoutes, { OtherRoutes } from './utils/Routes';
import { drawerWidth, footerHeight, headerHeight } from './utils/Common';
import NavbarMobile from './components/NavbarMobile';

function App() {
    const { state: authState, dispatch: setAuthState } = usePersistedReducer(authReducer, authInitialState, process.env.REACT_APP_AUTH_PERSIST_STORAGE_KEY);
    const { state: menuState, dispatch: setMenuState } = usePersistedReducer(menuReducer, menuInitialState, process.env.REACT_APP_MENU_PERSIST_STORAGE_KEY);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const providerState = useMemo(() => {
        const apiCaller = new ApiCaller({authState});

        return {
            authState,
            setAuthState,
            menuState,
            setMenuState,
            apiCaller,
        };
    }, [authState, setAuthState, menuState, setMenuState]);

    return (
        <StateContext.Provider value={providerState}>
            <BrowserRouter>
                <GlobalStyles styles={GlobalStyleTemplate} />
				<Box
                    component="main"
                    sx={{
                        width: "100vw",
                        height: "100vh",
                        '@supports (height: 100dvh)': {
                            height: '100dvh',
                        },
                        display: "flex",
                        padding: 0, // Ensure no padding is applied
                        overflowX: 'hidden', // Hide any overflow on X-axis
                        backgroundColor: "#fefefe",
                    }}
                >
                    <CssBaseline />
                    {authState?.username && authState?.token ? (
                        <>
                            <Navbar />
                            <Sidebar />
                            <Box
                                // onClick={() => {
                                //     if (menuState && menuState.showSidebar)
                                //         setMenuState({
                                //             ...menuState,
                                //             type: "toggle",
                                //             showSidebar: false,
                                //         });
                                // }}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    flex: 1,
                                    width: menuState?.showSidebar ? `calc(100vw - ${drawerWidth}px)` : "100vw",
                                    height: `calc(100vh - ${headerHeight}px - ${footerHeight}px)`,
                                    '@supports (height: 100dvh)': {
                                        height: `calc(100dvh - ${headerHeight}px - ${footerHeight}px)`,
                                    },
                                    backgroundColor: "#fff",
                                    marginTop: isMobile ? 0 : `${headerHeight}px`,
                                    marginBottom: isMobile ? `${headerHeight}px` : 0,
                                }}
                            >
                                <AppRoutes />
                            </Box>
                        {
                            isMobile ?
                            <NavbarMobile />
                            :
                            null
                        }
                            <Footer />
                        </>
                    ) : (
                        <OtherRoutes />
                    )}
                </Box>
            </BrowserRouter>
        </StateContext.Provider>
    );
}

export default App;
